import React from 'react';
import { FileBrowser } from '@os/components/FileBrowser';

interface SupabaseFileExplorerProps {
  onOpenFile?: (file: any, appType: string) => void;
}

export const SupabaseFileExplorer: React.FC<SupabaseFileExplorerProps> = ({ onOpenFile }) => {
  const handleFileSelect = (file: any) => {
    if (onOpenFile) {
      // Determine app type based on file type
      let appType = 'Notepad';
      const name = file?.name || file?.file_name || '';
      const ext = (file?.extension || '').toLowerCase();
      const mime = (file?.content_type || '').toLowerCase();
      
      // MapleWord
      if (
        mime === 'application/x-mapleword' ||
        mime === 'text/html' ||
        ext === 'mword' ||
        name.toLowerCase().endsWith('.mword')
      ) {
        appType = 'MapleWord';
      } else if (
        mime.includes('image') ||
        ['png','jpg','jpeg','gif','webp','bmp','svg'].includes(ext)
      ) {
        appType = 'Image Viewer';
      }
      
      onOpenFile(file, appType);
    }
  };

  return (
    <div className="w-full h-full">
      <FileBrowser
        isOpen={true}
        onClose={() => {}} // Always open in this mode
        onFileSelect={handleFileSelect}
        mode="browse"
        initialPath="C:\\"
      />
    </div>
  );
};